import { CBadge, Wrapper } from './styles';

interface IconNotificationProps {
  count?: any;
  icon: JSX.Element;
  offset?: any;
  background?: string;
  width?: string | undefined;
}

const IconNotification = ({
  count,
  icon,
  offset,
  background,
  width = '36px',
}: IconNotificationProps): JSX.Element => (
  <Wrapper background={background} width={width}>
    {icon}
    <CBadge
      className="site-badge-count-109"
      dot={count !== 0}
      offset={offset || [10, 4]}
    />
  </Wrapper>
);

export default IconNotification;
